// ** React Imports
import { ReactNode, useMemo } from 'react'
import { useFlag } from '@unleash/proxy-client-react'

// ** Mui Imports
import { Box } from '@mui/material'

//** Effect Imports
import { useStore } from 'effector-react'

// ** Source code Imports
import globalStore from 'src/state-manager/global'
import Header from './Header'
import Footer from './Footer'
import { socials, pages, menuList } from './opts'

interface IProps {
  sx?: { [key: string]: any }
  children: ReactNode
}

const DefaultLayout = ({ sx, children }: IProps) => {
  const { language } = useStore(globalStore.locale)

  const isLandingNewsAvailableFlag = useFlag('is_landing_news_available')

  const isLandingNewsAvailable = isLandingNewsAvailableFlag && language !== 'en'

  const visiblePages = useMemo(() => {
    return isLandingNewsAvailable ? pages : pages.filter(page => page.title !== 'news')
  }, [isLandingNewsAvailable])

  return (
    <Box sx={{ background: 'black', overflowX: 'hidden', ...sx }}>
      <Header pages={visiblePages} />
      {children}
      <Footer socials={socials} pages={visiblePages} menuList={menuList} />
    </Box>
  )
}

export default DefaultLayout
